import { SidenavUtils } from '@/common/utils/SideNavUtils';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';

const scSideNav = {
  id: 'sc',
  shortName: 'S & C',
  role: 'SC_VIEW',
  displayName: 'Sales & Concessions',
  icon: fas.faMoneyCheckAlt,
  precedence: 1,
  children: [
    // Organization Menu
    SidenavUtils.orgMenu('sc'),

    // Direct Sales
    {
      id: 'scDirSalesMenu',
      displayName: 'Direct Sales',
      role: 'SC_DIR_SALE_VIEW',
      icon: fas.faFileInvoice,
      precedence: 2,
      children: [
        {
          id: 'scDirSale',
          displayName: 'Sales',
          role: 'SC_DIR_SALE_VIEW',
          icon: fas.faFileInvoice,
          route: '/sc/dir-sale',
          precedence: 2,
        },
        // {
        //   id: 'scDirSaleNewFinDashboard',
        //   displayName: 'New Financial Dashboard',
        //   role: 'SC_DIR_SALE_VIEW',
        //   icon: fas.faChartBar,
        //   route: '/sc/dir-sale-new-fin-dashboard',
        //   precedence: 3,
        // },
        {
          id: 'scAdj',
          displayName: 'Adjustments',
          role: 'SC_ADJ_VIEW',
          icon: fas.faSlidersHSquare,
          route: '/sc/adj',
          precedence: 4,
        },
      ],
    },

    // Chargeback Section
    {
      id: 'scChbkMenu',
      displayName: 'Chargebacks',
      role: 'SC_CHBK_LEDGER_VIEW',
      icon: fas.faWarehouse,
      precedence: 4,
      children: [
        {
          id: 'scIndirSale',
          displayName: 'Indirect Sales',
          role: 'SC_INDIR_SALE_VIEW',
          icon: fas.faFileInvoice,
          route: '/sc/indir-sale',
          precedence: 3,
        },
        {
          id: 'scChbkLedger',
          displayName: 'Ledgers',
          role: 'SC_CHBK_LEDGER_VIEW',
          icon: fas.faClipboard,
          route: '/sc/chbk-ledger',
          precedence: 6,
        },
        {
          id: 'scChbkPymt',
          displayName: 'Payments',
          role: 'SC_PYMT_VIEW',
          icon: fas.faDollarSign,
          route: '/sc/pymt/chbk',
          precedence: 7,
        },
        {
          id: 'scChbkDashboard',
          displayName: 'Indirect Sale Dashboard',
          role: 'SC_CHBK_LEDGER_VIEW',
          icon: fas.faChartBar,
          route: '/sc/chbk-dashboard',
          precedence: 5,
        },
        {
          id: 'scChbkFinDashboard',
          displayName: 'Financial Dashboard',
          role: 'SC_CHBK_LEDGER_VIEW',
          icon: fas.faChartBar,
          route: '/sc/chbk-fin-dashboard',
          precedence: 6,
        },
        {
          id: 'scChannelData',
          displayName: 'Channel Data',
          role: 'SC_CHANNEL_DATA_VIEW',
          icon: fas.faFileChartLine,
          route: '/sc/channel-data',
          precedence: 8,
        },
        {
          id: 'scShpmnt',
          displayName: 'Shipments',
          role: 'SC_SHPMNT_VIEW',
          icon: fas.faBoxOpen,
          route: '/sc/shpmnt',
          precedence: 9,
        },
        {
          id: 'scAcctBal',
          displayName: 'Account Balance',
          role: 'SC_ACCT_BAL_VIEW',
          icon: fas.faFileChartLine,
          route: '/sc/acct-bal',
          precedence: 10,
        },
      ],
    },

    // Incentive Section
    {
      id: 'scInctvMenu',
      displayName: 'Incentive',
      role: 'SC_INCTV_LEDGER_VIEW',
      icon: fas.faTag,
      precedence: 11,
      children: [
        {
          id: 'scInctvRbt',
          displayName: 'Rebates',
          role: 'SC_INCTV_RBT_VIEW',
          icon: fas.faFilePrescription,
          route: '/sc/inctv-rbt',
          precedence: 12,
        },
        {
          id: 'scInctvLedger',
          displayName: 'Ledgers',
          role: 'SC_INCTV_LEDGER_VIEW',
          icon: fas.faClipboard,
          route: '/sc/inctv-ledger',
          precedence: 13,
        },
        {
          id: 'scInctvPymt',
          displayName: 'Payments',
          role: 'SC_PYMT_VIEW',
          icon: fas.faDollarSign,
          route: '/sc/pymt/inctv',
          precedence: 14,
        },
        {
          id: 'scInctvRbtDashboard',
          displayName: 'Rebate Dashboard',
          role: 'SC_INCTV_RBT_VIEW',
          icon: fas.faChartBar,
          route: '/sc/inctv-rbt-dashboard',
          precedence: 10,
        },
      ],
    },
    {
      id: 'scDsaMenu',
      displayName: 'DSA',
      role: 'SC_INCTV_LEDGER_VIEW',
      icon: fas.faTag,
      precedence: 11,
      children: [
        {
          id: 'scInctvDashboard',
          displayName: 'DSA/SD Dashboard',
          role: 'SC_INCTV_LEDGER_VIEW',
          icon: fas.faChartLine,
          route: '/sc/dashboard/inctv-ledger',
          precedence: 30,
        },
      ],
    },

    // Managed Care Section
    {
      id: 'scMcoMenu',
      displayName: 'Managed Care',
      role: 'SC_MCO_LEDGER_VIEW',
      icon: fas.faClinicMedical,
      precedence: 14,
      children: [
        {
          id: 'scMcoInvDashboard',
          displayName: 'Invoice Dashboard',
          role: 'SC_MCO_INV_VIEW',
          icon: fas.faChartBar,
          route: '/sc/mco-dashboard',
          precedence: 15,
        },
        {
          id: 'scMcoFinDashboard',
          displayName: 'Financial Dashboard',
          role: 'SC_MCO_INV_VIEW',
          icon: fas.faChartBar,
          route: '/sc/mco-fin-dashboard',
          precedence: 16,
        },
        {
          id: 'scMcoInv',
          displayName: 'Invoices',
          role: 'SC_MCO_INV_VIEW',
          icon: fas.faFilePrescription,
          route: '/sc/mco-inv',
          precedence: 17,
        },
        {
          id: 'scMcoRbt',
          displayName: 'Rebates',
          role: 'SC_MCO_RBT_VIEW',
          icon: fas.faChartBar,
          route: '/sc/mco-rbt',
          precedence: 18,
        },
        {
          id: 'scMcoLedger',
          displayName: 'Ledgers',
          role: 'SC_MCO_LEDGER_VIEW',
          icon: fas.faClipboard,
          route: '/sc/mco-ledger',
          precedence: 19,
        },
        {
          id: 'scMcoPymt',
          displayName: 'Payments',
          role: 'SC_PYMT_VIEW',
          icon: fas.faDollarSign,
          route: '/sc/pymt/mco',
          precedence: 20,
        },
        // {
        //   id: 'scMcoInvLineProgProd',
        //   displayName: 'Invoice Lines Program Products',
        //   role: 'SC_MCO_INV_LINE_PROG_PROD_VIEW',
        //   icon: fas.faChartBar,
        //   route: '/sc/mco-inv-line-prog-prod',
        //   precedence: 22,
        // },
        {
          id: 'scMcoRbtLine',
          displayName: 'Rebate Lines',
          role: 'SC_MCO_RBT_LINE_VIEW',
          icon: fas.faChartBar,
          route: '/sc/mco-rbt-line',
          precedence: 23,
        },
      ],
    },

    // Medicaid Section
    {
      id: 'scMcdMenu',
      displayName: 'Medicaid',
      role: 'SC_MCD_INV_VIEW',
      icon: fas.faHospitalUser,
      precedence: 20,
      children: [
        {
          id: 'scMcdInv',
          displayName: 'Invoices',
          role: 'SC_MCD_INV_VIEW',
          icon: fas.faChartBar,
          route: '/sc/mcd-inv',
          precedence: 22,
        },
        {
          id: 'scMcdRbt',
          displayName: 'Rebates',
          role: 'SC_MCD_RBT_VIEW',
          icon: fas.faChartBar,
          route: '/sc/mcd-rbt',
          precedence: 23,
        },
        {
          id: 'scMcdLedger',
          displayName: 'Ledgers',
          role: 'SC_MCD_LEDGER_VIEW',
          icon: fas.faClipboard,
          route: '/sc/mcd-ledger',
          precedence: 25,
        },
        {
          id: 'scMcdPymt',
          displayName: 'Payments',
          role: 'SC_PYMT_VIEW',
          icon: fas.faDollarSign,
          route: '/sc/pymt/mcd',
          precedence: 26,
        },
        {
          id: 'scMcdInvDashboard',
          displayName: 'Invoice Dashboard',
          role: 'SC_MCD_INV_VIEW',
          icon: fas.faChartBar,
          route: '/sc/mcd-dashboard',
          precedence: 20,
        },
        {
          id: 'scMcdFinDashboard',
          displayName: 'Financial Dashboard',
          role: 'SC_MCD_INV_VIEW',
          icon: fas.faChartBar,
          route: '/sc/mcd-inv-fin-dashboard',
          precedence: 20,
        },
        {
          id: 'scMcdRbtLine',
          displayName: 'Rebate Lines',
          role: 'SC_MCD_RBT_LINE_VIEW',
          icon: fas.faChartBar,
          route: '/sc/mcd-rbt-line',
          precedence: 22,
        },
      ],
    },

    // MFP Section
    {
      id: 'scMfpMenu',
      displayName: 'MFP',
      role: 'SC_MFP_VIEW',
      icon: fas.faNotesMedical,
      precedence: 25,
      children: [
        {
          id: 'scMfpBoard',
          displayName: 'Lifecycle Board',
          role: 'SC_MFP_LEDGER_VIEW',
          icon: fas.faChartBar,
          route: '/sc/board/mfp-ledger',
          precedence: 26,
        },
        {
          id: 'scMfpUtil',
          displayName: 'Utilizations',
          role: 'SC_MFP_UTIL_VIEW',
          icon: fas.faFilePrescription,
          route: '/sc/mfp-util',
          precedence: 27,
        },
        {
          id: 'scMfpLedger',
          displayName: 'Ledgers',
          role: 'SC_MFP_LEDGER_VIEW',
          icon: fas.faClipboard,
          route: '/sc/mfp-ledger',
          precedence: 28,
        },
        {
          id: 'scMfpPymt',
          displayName: 'Payments',
          role: 'SC_MFP_PYMT_VIEW',
          icon: fas.faDollarSign,
          route: '/sc/mfp-pymt',
          precedence: 29,
        },
        {
          id: 'scMfpCredit',
          displayName: 'Credits',
          role: 'SC_MFP_CREDIT_VIEW',
          icon: fas.faHandsUsd,
          route: '/sc/mfp-credit',
          precedence: 30,
        },
      ],
    },
    // External Data
    {
      id: 'extData',
      displayName: 'External Data',
      role: 'SC_EXT_DATA_VIEW',
      icon: fas.faListUl,
      precedence: 35,
      children: [
        {
          id: 'scBrgDupDiscCheck',
          displayName: 'BRG Duplicate Checks',
          role: 'SC_BRG_DUP_DISC_CHECK_VIEW',
          icon: fas.faClipboard,
          route: '/sc/brg-dup-disc-check',
          precedence: 36,
        },
      ],
    },

    // Common Menus
    ...SidenavUtils.commonMenus('sc'),
  ],
};

export default scSideNav;
